import { Directive, inject } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalData } from '@shared/components/confirmation-modal/confirmation-modal.model';
import { filter, tap } from 'rxjs';
import { getConfirmationData } from '../../../shared/helpers/get-confirmation-data.helper';
import { RegisterGuardianshipFormService } from '../register-guardianship-form.service';
import { ClerkCreateGuardianshipFacadeService } from '../clerk-create-guardianship-facade.service';

@Directive({
  selector: '[appHandleClerkCreateGuardianshipSubmit]',
  host: { '(ngSubmit)': 'handleClick()' },
})
export class HandleClerkCreateGuardianshipSubmitDirective {
  private readonly _formService = inject(RegisterGuardianshipFormService);
  private readonly _dialog = inject(Dialog);
  private readonly _submitFacade = inject(ClerkCreateGuardianshipFacadeService);
  private readonly _dialogRef = inject(DialogRef);

  private readonly _form = this._formService.form;

  private readonly _confirmationData: ConfirmationModalData =
    getConfirmationData('G&C');

  protected handleClick() {
    const isLinkingUser = this._form.controls.userId.value !== 0;
    if (!isLinkingUser) {
      this._dialogRef.close();
      this._submitFacade.submitApplication();
      return;
    }

    this._dialogRef.close();
    const dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: this._confirmationData,
    });

    dialogRef.closed
      .pipe(
        filter((confirmed) => !!confirmed),
        tap(() => {
          this._submitFacade.submitApplication();
        }),
      )
      .subscribe();
  }
}
